import { useEffect, useState } from "react";
import axios from "../../../../requests/axios";
import routes from "../../../../requests/routes";
import Loader from "../../../../layouts/loader/Loader";
import UserCard from "../userCard/UserCard";
import classes from "./UserGallery.module.scss";
import { FallbackImage } from "../../../../generic components/ImageWithfallback/ImageWithfallback";

export const UserGallery = ({ record }) => {
  const gallery = record.gallery;

  return (
    <>
      {gallery && gallery.length > 0 && (
        <div className={classes.gallery_wrapper}>
          {gallery.map((wl, index) => (
            <div className={classes.gallery_wrapper__image}>
              <FallbackImage src={wl} key={index} />
            </div>
          ))}
        </div>
      )}
    </>
  );
};
